import React, { useState } from 'react';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import api from './api/client';
import { parse, format } from 'date-fns'; // Добавляем этот импорт


const ScannerShipments = () => {
    const [scannedData, setScannedData] = useState('');
    const [entries, setEntries] = useState(new Set());
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    // const parseScannedData = (data) => {
    //     const lines = data.trim().split('\n');
    
    //     console.log('Raw input data:', lines);
    
    //     const parsedEntries = lines.map((line, index) => {
    //         try {
    //             console.log(`Processing line ${index + 1}:`, line);
    
    //             // Разделяем строку на части по шаблону
    //             const match = line.match(/^(\d{4}\/\d{2}\/\d{2}) (\d{2}:\d{2}:\d{2}) ([A-Z]+)-(.+?), (.+?), BOX#(.+?)\/(\d+)$/);
    
    //             if (!match) {
    //                 throw new Error(`Row ${index + 1}: Invalid format.`);
    //             }
    
    //             const [, dateStr, time, prefix, setName, sku, boxNumber, quantity] = match;
    
    //             console.log(`Parsed values for line ${index + 1}:`, {
    //                 dateStr,
    //                 time,
    //                 prefix,
    //                 setName,
    //                 sku,
    //                 boxNumber,
    //                 quantity
    //             });
    
    //             // Преобразование даты
    //             const parsedDate = parse(dateStr, 'yyyy/MM/dd', new Date());
    //             if (isNaN(parsedDate)) {
    //                 throw new Error(`Row ${index + 1}: Invalid date format.`);
    //             }
    //             const formattedDate = format(parsedDate, 'yyyy-MM-dd');
    
    //             return {
    //                 sku: sku.trim(),
    //                 boxNumber: boxNumber.trim(),
    //                 quantity: parseInt(quantity.trim(), 10),
    //                 date: formattedDate,
    //                 time: time.trim(),
    //                 destination: prefix === 'SHIP' ? 'FBA' : 'Shipping Station',
    //                 setName: setName.trim()
    //             };
    //         } catch (error) {
    //             console.error(`Row ${index + 1}: ${error.message}`);
    //             return null;
    //         }
    //     });
    
    //     // Удаление дубликатов по SKU и Box Number
    //     const uniqueEntries = [];
    //     const seen = new Set();
    
    //     parsedEntries.forEach(entry => {
    //         if (entry) {
    //             const key = `${entry.sku}-${entry.boxNumber}`;
    //             if (!seen.has(key)) {
    //                 seen.add(key);
    //                 uniqueEntries.push(entry);
    //             }
    //         }
    //     });
    
    //     console.log('Final parsed entries:', uniqueEntries);
    //     return uniqueEntries;
    // };
    
    const parseScannedData = (data) => {
        const lines = data.trim().split('\n');
    
        console.log('Raw input data:', lines);
    
        const parsedEntries = lines.map((line, index) => {
            try {
                console.log(`Processing line ${index + 1}:`, line);
    
                // Регулярное выражение для учета даты и времени в начале или в конце
                // const match = line.match(/^(?:(\d{4}\/\d{2}\/\d{2}) (\d{2}:\d{2}:\d{2}) )?([A-Z]+-\d+ .+?), (.+?), BOX#(.+?)\/(\d+)(?: (\d{4}\/\d{2}\/\d{2}) (\d{2}:\d{2}:\d{2}))?$/);
                // Name is greedy (may contain commas), SKU is the last comma-free part before BOX#
                const match = line.match(
                    /^(?:(\d{4}\/\d{2}\/\d{2}) (\d{2}:\d{2}:\d{2}) )?(.+), ([^,]+), BOX#(.+?)\/(\d+)(?: (\d{4}\/\d{2}\/\d{2}) (\d{2}:\d{2}:\d{2}))?$/
                );

                if (!match) {
                    throw new Error(`Row ${index + 1}: Invalid format.`);
                }

                let [, dateStart, timeStart, prefixSetName, sku, boxNumber, quantity, dateEnd, timeEnd] = match;

                // Определяем, где находится дата (в начале или в конце)
                const dateStr = dateStart || dateEnd || null;
                const time = timeStart || timeEnd || null;

                console.log(`Parsed values for line ${index + 1}:`, {
                    dateStr,
                    time,
                    prefixSetName,
                    sku,
                    boxNumber,
                    quantity
                });

                // Преобразование даты (если нет — текущая дата/время по Майами)
                let formattedDate, formattedTime;
                if (dateStr) {
                    const parsedDate = parse(dateStr, 'yyyy/MM/dd', new Date());
                    if (isNaN(parsedDate)) {
                        throw new Error(`Row ${index + 1}: Invalid date format.`);
                    }
                    formattedDate = format(parsedDate, 'yyyy-MM-dd');
                    formattedTime = time ? time.trim() : null;
                } else {
                    const miamiNow = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });
                    const miamiDate = new Date(miamiNow);
                    formattedDate = format(miamiDate, 'yyyy-MM-dd');
                    formattedTime = format(miamiDate, 'HH:mm:ss');
                }

                // Если первая часть до дефиса — только заглавные буквы, это префикс сканера
                const parts = prefixSetName.split('-');
                const hasPrefix = /^[A-Z]+$/.test(parts[0]);
                const setName = hasPrefix ? parts.slice(1).join('-').trim() : prefixSetName.trim();
    
                return {
                    sku: sku.trim(),
                    boxNumber: boxNumber.trim(),
                    quantity: parseInt(quantity.trim(), 10),
                    date: formattedDate,
                    time: formattedTime,
                    destination: 'Shipping Station',
                    setName
                };
            } catch (error) {
                console.error(`Row ${index + 1}: ${error.message}`);
                return null;
            }
        });
    
        // Удаление дубликатов по SKU и Box Number
        const uniqueEntries = [];
        const seen = new Set();
    
        parsedEntries.forEach(entry => {
            if (entry) {
                const key = `${entry.sku}-${entry.boxNumber}`;
                if (!seen.has(key)) {
                    seen.add(key);
                    uniqueEntries.push(entry);
                }
            }
        });
    
        console.log('Final parsed entries:', uniqueEntries);
        return uniqueEntries;
    };
    
    
    const handleSave = async () => {
        setError('');
        setSuccess(false);

        try {
            const parsedData = parseScannedData(scannedData);

            if (parsedData.length === 0) {
                setError('No valid entries to save.');
                return;
            }

            // Отправка данных на сервер
            await api.post(`/api/scannershipments`, { data: parsedData });

            // Обновляем SS Stock (добавляем кол-во из коробок)
            api.post(`/api/ss-stock/add-boxes`, { data: parsedData }).catch(() => {});

            setSuccess(true);
            setScannedData('');
            setEntries(prevEntries => new Set([...prevEntries, ...parsedData]));
        } catch (err) {
            setError(err.response?.data?.details || err.response?.data?.error || 'Failed to save data.');
            console.error(err);
        }
    };
    

    return (
        <div className="scanners-inv-seeds-page-bg">
            <HeaderLogged />
            <Container>
                <div className="scan-sealed-sets">
                    <h1 className="scan-sealed-sets-h">Scan to ship boxes (Shipping Station Only)</h1>
                    <textarea
                        value={scannedData}
                        onChange={(e) => setScannedData(e.target.value)}
                        placeholder="Scan QR code on the box"
                        className="scanned-input"
                    ></textarea>
                    <button onClick={handleSave} className="save-btn">Save</button>
                    {success && <p style={{ color: 'green' }}>Data saved successfully!</p>}
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                </div>
            </Container>

            <style jsx>{`
                .scan-sealed-sets {
                    margin-top: 150px;
                    z-index: 1;
                    position: relative;
                }
                .scan-sealed-sets-h {
                    margin-bottom: 20px;
                    color: #404340;
                    text-transform: uppercase;
                    font-weight: bold;
                }
                .scanned-input {
                    width: 100%;
                    height: 100px;
                    padding: 10px;
                    border: 1px solid #4caf50;
                    border-radius: 5px;
                    margin-bottom: 10px;  
                }
                .add-entry-btn, .save-btn {
                    background-color: #4caf50;
                    color: white;
                    padding: 10px 20px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    margin-top: 10px;
                }
                .add-entry-btn:hover, .save-btn:hover {
                    background-color: #45a049;
                }
                .entries-list {
                    margin-top: 10px;
                    list-style-type: none;
                    padding: 0;
                }
                .entries-list li {
                    background-color: #e8f5e9;
                    padding: 10px;
                    border: 1px solid #c8e6c9;
                    border-radius: 5px;
                    margin-bottom: 5px;
                }
            `}</style>
        </div>
    );
};

export default ScannerShipments;
